<template>
  <feather-icon icon="HelpCircleIcon" size="13" class="jb-info-hint" v-b-tooltip.hover.top="text"/>
</template>

<script>
import {VBTooltip} from 'bootstrap-vue'

/** A small "?" that explains a setting on hover — used across the journey builder. */
export default {
  name: 'InfoHint',
  directives: {'b-tooltip': VBTooltip},
  props: {
    text: {type: String, required: true},
  },
}
</script>

<style scoped>
.jb-info-hint {
  color: #b9b9c3;
  cursor: help;
  margin-left: 4px;
  vertical-align: -2px;
}
</style>
